export default __webpack_public_path__ + "static/media/cosecha.3811decb.png";